
function fromFunction (sourceFunction) {
    let code = sourceFunction.toString()
    code = removeSurroundingFunction(code)
    code = stripWrongSpaces(code)
    return code
}



function removeSurroundingFunction (code) {
    code = code.replace(/function [\s]*\(\) {/, "")
    code = code.replace(/}$/g, "")

    return code
}



function stripWrongSpaces (code) {
    code = code.split(/\n/)

    let startingSpaces = Infinity
    let trimedLine

    let newCode = []
    let allPreviousLinesEmpty = true

    for (let i = 0; i < code.length; i++) {
        trimedLine = code[i].replace(/^\s+/g, "")
        if (trimedLine.length > 0) {
            startingSpaces = Math.min(code[i].length - trimedLine.length, startingSpaces)
            allPreviousLinesEmpty = false
        }
        if (!allPreviousLinesEmpty) {
            newCode.push(code[i])
        }
    }

    for (let j = 0; j < newCode.length; j++) {
        newCode[j] = newCode[j].slice(startingSpaces)
    }

    return newCode.join("\n")
}



export default {
    fromFunction,
    stripWrongSpaces
}
